import ExceptionHandler from './ExceptionHandler.container'

export default ExceptionHandler
